import styled from 'styled-components';
import { StackPanel, Typography } from '@agilepoint/wat-react-ux';
import { getErrorMessage } from 'common/utils/error-message-utils';
import { ReactComponent as ErrorIllustration } from '../../../assets/svg/error.svg';

interface IAPIErrorProps {
    errorObject: unknown;
    headerMessage?: string;
    showReloadButton?: boolean;
}

const StyledStackPanel = styled(StackPanel)`
    max-height: 600px;
    margin: 12px;
`;

const IllustrationWrapper = styled.div`
    width: 70%;
    height: 50%;
    text-align: center;
    padding: 16px 12px 2px;
    border-radius: 12px;
    margin-bottom: 12px;
`;

const StyledErrorMessage = styled.div`
    font-size: 14px;
    width: 60%;
    color: #B6383E;
    white-space: pre-wrap;
    max-height: 225px;
    overflow: auto;
`;

export function ErrorInfo(props: IAPIErrorProps) {
    const { errorObject, headerMessage } = props;
    const errorMessage = getErrorMessage(errorObject);
    return (
        <StyledStackPanel orientation="vertical" width="calc(100% - 24px)" height="calc(100% - 24px)" justifyContent="center" alignment="center">
            <div>
                {
                    headerMessage ?
                        <Typography.H1>
                            {headerMessage}
                        </Typography.H1> : <></>}
            </div>
            <IllustrationWrapper>
                <ErrorIllustration />
            </IllustrationWrapper>
            <StyledErrorMessage>
                {errorMessage}
            </StyledErrorMessage>
        </StyledStackPanel>
    );
}
